import { ApplicationRejectionStep } from '@/@types/generated'
import { register } from './enum'

const ApplicationRejectionStepLabels: Record<ApplicationRejectionStep, string> =
  {
    [ApplicationRejectionStep.REVIEW_SAFER]: 'Review SAFER',
    [ApplicationRejectionStep.BUSINESS_INFORMATION]: 'Business Structure',
    [ApplicationRejectionStep.TEXAS_AGENT]: 'Texas Agent',
    [ApplicationRejectionStep.INTERSTATE_UCR]: 'Interstate UCR',
    [ApplicationRejectionStep.REGISTRATION_PERIOD]: 'Registration Period',
    [ApplicationRejectionStep.CARGO_TYPES]: 'Cargo Types',
    [ApplicationRejectionStep.VEHICLES]: 'Vehicles',
    [ApplicationRejectionStep.DRUG_TEST_CERTIFICATION]:
      'Drug Test Certification',
    [ApplicationRejectionStep.QUESTIONNAIRE]: 'Questionnaire',
    [ApplicationRejectionStep.BROKER_DOCUMENTS]: 'Broker Documents',
  }

register<ApplicationRejectionStep>(ApplicationRejectionStep, (v) => {
  if (!v) return '—'
  return ApplicationRejectionStepLabels[v]
})
